import { render } from "./AddPayment.vue?vue&type=template&id=6c875960&scoped=true"
import script from "./AddPayment.vue?vue&type=script&lang=js"
export * from "./AddPayment.vue?vue&type=script&lang=js"

import "./AddPayment.vue?vue&type=style&index=0&id=6c875960&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\estimate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c875960"]])

export default __exports__